// Mock data for TrainPanda

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_5f4c9922-2426-4cc9-8dff-a0f4b74e8489/artifacts/to1gtggc_ChatGPT_Image_May_2__2026__04_45_09_PM__1_-removebg-preview.png";

export const POPULAR_ROUTES = [
  { from: 'New Delhi', to: 'Mumbai Central', fromCode: 'NDLS', toCode: 'MMCT', trains: 48 },
  { from: 'Howrah Jn', to: 'New Delhi', fromCode: 'HWH', toCode: 'NDLS', trains: 32 },
  { from: 'Chennai Central', to: 'Bengaluru', fromCode: 'MAS', toCode: 'SBC', trains: 27 },
  { from: 'Ahmedabad Jn', to: 'Mumbai Central', fromCode: 'ADI', toCode: 'MMCT', trains: 41 },
  { from: 'Secunderabad', to: 'Chennai Central', fromCode: 'SC', toCode: 'MAS', trains: 19 },
  { from: 'Pune Jn', to: 'New Delhi', fromCode: 'PUNE', toCode: 'NDLS', trains: 14 },
];

export const POPULAR_STATIONS = [
  { code: 'NDLS', name: 'New Delhi', restaurants: 42 },
  { code: 'BPL', name: 'Bhopal Jn', restaurants: 18 },
  { code: 'NGP', name: 'Nagpur Jn', restaurants: 22 },
  { code: 'ALD', name: 'Prayagraj Jn', restaurants: 15 },
  { code: 'KYN', name: 'Kalyan Jn', restaurants: 11 },
  { code: 'JBP', name: 'Jabalpur Jn', restaurants: 9 },
  { code: 'GZB', name: 'Ghaziabad', restaurants: 13 },
  { code: 'CNB', name: 'Kanpur Central', restaurants: 26 },
];

export const FEATURES = [
  { title: 'Live Train Running Status', desc: 'Get real-time train location, platform number and delay info with 95% accuracy.', icon: 'Activity', to: '/live-train-status' },
  { title: 'PNR Status Check', desc: 'Check latest PNR confirmation status, coach and berth details instantly.', icon: 'Ticket', to: '/pnr-status' },
  { title: 'Food on Train', desc: 'Order hot meals from 500+ FSSAI-approved restaurants delivered at your seat.', icon: 'UtensilsCrossed', to: '/food-on-train' },
  { title: 'Train Time Table', desc: 'Complete schedule, intermediate halts, arrival and departure timings.', icon: 'Clock', to: '/live-train-status' },
];

export const TRAINS = [
  { number: '12951', name: 'Mumbai Rajdhani', from: 'New Delhi', to: 'Mumbai Central', departure: '16:55', arrival: '08:35', duration: '15h 40m' },
  { number: '12259', name: 'Sealdah Duronto', from: 'Sealdah', to: 'New Delhi', departure: '20:05', arrival: '10:00', duration: '13h 55m' },
  { number: '12002', name: 'Shatabdi Express', from: 'New Delhi', to: 'Bhopal Jn', departure: '06:00', arrival: '14:05', duration: '8h 05m' },
  { number: '12309', name: 'Rajendranagar Rajdhani', from: 'Rajendranagar', to: 'New Delhi', departure: '19:25', arrival: '07:40', duration: '12h 15m' },
  { number: '22691', name: 'Rajdhani Express', from: 'Bengaluru', to: 'H. Nizamuddin', departure: '20:00', arrival: '05:55', duration: '33h 55m' },
];

export const MOCK_PNR_RESULT = {
  pnr: '8921456732',
  trainNumber: '12951',
  trainName: 'MUMBAI RAJDHANI',
  boardingDate: '28 Jul 2025',
  from: 'NDLS - New Delhi',
  to: 'MMCT - Mumbai Central',
  reservedUpto: 'MMCT - Mumbai Central',
  boardingPoint: 'NDLS - New Delhi',
  class: '3A',
  chartStatus: 'CHART NOT PREPARED',
  passengers: [
    { no: 1, bookingStatus: 'CNF/B4/32', currentStatus: 'CNF/B4/32', coachPosition: '-' },
    { no: 2, bookingStatus: 'CNF/B4/33', currentStatus: 'CNF/B4/33', coachPosition: '-' },
    { no: 3, bookingStatus: 'RAC 12', currentStatus: 'CNF/B5/14', coachPosition: '-' },
  ],
};

export const MOCK_LIVE_STATUS = {
  trainNumber: '12951',
  trainName: 'Mumbai Rajdhani',
  currentStation: 'Ratlam Jn (RTM)',
  nextStation: 'Vadodara Jn (BRC)',
  delay: 'On Time',
  lastUpdated: '2 mins ago',
  platform: 3,
  speed: 108,
  distanceCovered: 689,
  totalDistance: 1384,
  schedule: [
    { station: 'New Delhi (NDLS)', sch: '16:55', act: '16:55', delay: 'On Time', day: 1, status: 'departed', platform: 16 },
    { station: 'Kota Jn (KOTA)', sch: '22:08', act: '22:12', delay: '4 min late', day: 1, status: 'departed', platform: 2 },
    { station: 'Ratlam Jn (RTM)', sch: '01:27', act: '01:27', delay: 'On Time', day: 2, status: 'current', platform: 3 },
    { station: 'Vadodara Jn (BRC)', sch: '04:42', act: '04:42', delay: 'On Time', day: 2, status: 'upcoming', platform: 4 },
    { station: 'Surat (ST)', sch: '06:22', act: '06:25', delay: '3 min late', day: 2, status: 'upcoming', platform: 2 },
    { station: 'Mumbai Central (MMCT)', sch: '08:35', act: '08:35', delay: 'On Time', day: 2, status: 'upcoming', platform: 3 },
  ],
};

export const RESTAURANTS = [
  { id: 'r1', name: 'RailRecipe Multi Cuisine', station: 'BPL', rating: 4.3, veg: true, time: '35-45 min', price: 249, image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=600', cuisines: ['North Indian', 'Chinese'], fssai: '12345678901234', minOrder: 150 },
  { id: 'r2', name: 'Gourmet Grub Express', station: 'BPL', rating: 4.5, veg: false, time: '25-35 min', price: 299, image: 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600', cuisines: ['Biryani', 'Mughlai'], fssai: '23456789012345', minOrder: 199 },
  { id: 'r3', name: 'South Spice Stop', station: 'BPL', rating: 4.1, veg: true, time: '30-40 min', price: 199, image: 'https://images.unsplash.com/photo-1630851840633-bb6ef6ad3adf?w=600', cuisines: ['South Indian'], fssai: '34567890123456', minOrder: 120 },
  { id: 'r4', name: 'Jain Bhoj', station: 'BPL', rating: 4.6, veg: true, time: '40-50 min', price: 279, image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=600', cuisines: ['Jain', 'Gujarati'], fssai: '45678901234567', minOrder: 150 },
  { id: 'r5', name: 'Pizza Junction', station: 'NDLS', rating: 4.2, veg: false, time: '30-40 min', price: 349, image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=600', cuisines: ['Italian', 'Fast Food'], fssai: '56789012345678', minOrder: 200 },
  { id: 'r6', name: 'Thali House', station: 'NDLS', rating: 4.4, veg: true, time: '25-35 min', price: 249, image: 'https://images.unsplash.com/photo-1567337710282-00832b415979?w=600', cuisines: ['North Indian'], fssai: '67890123456789', minOrder: 150 },
];

export const MENU_ITEMS = {
  r1: [
    { id: 'm1', name: 'Veg Thali (North Indian)', price: 249, veg: true, desc: '4 Roti, Dal, Sabji, Rice, Pickle, Papad', image: 'https://images.unsplash.com/photo-1567337710282-00832b415979?w=400' },
    { id: 'm2', name: 'Paneer Butter Masala + Rice', price: 229, veg: true, desc: 'Rich creamy paneer gravy with jeera rice', image: 'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400' },
    { id: 'm3', name: 'Hakka Noodles', price: 179, veg: true, desc: 'Indo-chinese stir fried noodles', image: 'https://images.unsplash.com/photo-1626804475297-41608ea09aeb?w=400' },
    { id: 'm4', name: 'Masala Dosa + Chutney', price: 159, veg: true, desc: 'Crispy dosa with potato filling', image: 'https://images.unsplash.com/photo-1630383249896-424e482df921?w=400' },
  ],
  r2: [
    { id: 'm5', name: 'Chicken Biryani', price: 329, veg: false, desc: 'Hyderabadi dum biryani with raita', image: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=400' },
    { id: 'm6', name: 'Mutton Rogan Josh', price: 399, veg: false, desc: 'Kashmiri style slow cooked mutton', image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400' },
    { id: 'm7', name: 'Butter Chicken + Naan', price: 349, veg: false, desc: 'Creamy tomato gravy with butter naan', image: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400' },
  ],
  r3: [
    { id: 'm8', name: 'Idli Sambar (4 pcs)', price: 129, veg: true, desc: 'Steamed rice cakes with sambar', image: 'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?w=400' },
    { id: 'm9', name: 'Mini Meals', price: 179, veg: true, desc: 'Sambar rice, curd rice, rasam, papad', image: 'https://images.unsplash.com/photo-1625398407937-2af0d1b69d1e?w=400' },
  ],
  r4: [
    { id: 'm10', name: 'Jain Thali', price: 279, veg: true, desc: 'No onion no garlic thali', image: 'https://images.unsplash.com/photo-1567337710282-00832b415979?w=400' },
  ],
  r5: [
    { id: 'm11', name: 'Farmhouse Pizza', price: 349, veg: true, desc: 'Loaded with fresh vegetables', image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400' },
    { id: 'm12', name: 'Chicken Tikka Pizza', price: 399, veg: false, desc: 'Indian spiced chicken on crispy base', image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400' },
  ],
  r6: [
    { id: 'm13', name: 'Rajasthani Thali', price: 249, veg: true, desc: 'Dal baati churma with accompaniments', image: 'https://images.unsplash.com/photo-1626132647523-66c8b1fbd58c?w=400' },
  ],
};

export const OFFERS = [
  { code: 'TRAIN50', title: 'Flat ₹50 Off', sub: 'On food orders above ₹299' },
  { code: 'FIRST100', title: 'Flat ₹100 Off', sub: 'For first-time food users' },
  { code: 'PANDA20', title: '20% Off', sub: 'Up to ₹150 on all orders' },
];

export const ADMIN_STATS = {
  totalUsers: 12847,
  totalOrders: 4521,
  revenue: 892340,
  activeTrains: 158,
  scrapeSuccess: 96.4,
  topRoutes: [
    { route: 'NDLS → MMCT', count: 320 },
    { route: 'HWH → NDLS', count: 278 },
    { route: 'MAS → SBC', count: 214 },
  ],
};
